import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFunnel, Challenge } from '../../contexts/FunnelContext'
import { ProgressBar } from '../../components/funnel/ProgressBar'
import { ChallengeCard } from '../../components/funnel/ChallengeCard'
import { PrimaryButton } from '../../components/funnel/PrimaryButton'
import { LoadingSpinner } from '../../components/funnel/LoadingSpinner'

const challenges: { key: Challenge; label: string }[] = [
  { key: 'high-energy-bills', label: 'High energy bills' },
  { key: 'unexpected-repairs', label: 'Unexpected repairs' },
  { key: 'drafty-windows', label: 'Drafty windows or doors' },
  { key: 'plumbing-leaks', label: 'Plumbing or leak worries' },
  { key: 'maintenance-upkeep', label: 'Keeping up with maintenance' },
  { key: 'trusted-contractors', label: 'Finding trusted contractors' },
]

const Step2Page: React.FC = () => {
  const navigate = useNavigate()
  const { state, toggleChallenge } = useFunnel()
  const [isLoading, setIsLoading] = useState(false)

  const handleContinue = async () => {
    if (state.challenges.length > 0) {
      setIsLoading(true)
      await new Promise((resolve) => setTimeout(resolve, 500))
      navigate('/winter-refresh/step-3')
    }
  }

  return (
    <div style={{ backgroundColor: 'rgb(246, 246, 241)', minHeight: '100vh', padding: '2rem 0' }}>
      <div className="mx-auto max-w-2xl px-8">
        <ProgressBar currentStep={2} totalSteps={4} />

        <h2 className="text-3xl font-semibold mb-4" style={{ color: 'rgb(15,15,15)' }}>
          What's on your mind this winter?
        </h2>

        <h3 className="text-xl font-medium mb-6" style={{ color: 'rgb(15,15,15)' }}>
          Select your top 1-3 concerns. This helps us understand your priorities.
        </h3>

        <div
          className="grid gap-4 mb-8"
          style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}
        >
          {challenges.map((challenge) => (
            <ChallengeCard
              key={challenge.key}
              text={challenge.label}
              selected={state.challenges.includes(challenge.key)}
              onClick={() => toggleChallenge(challenge.key)}
            />
          ))}
        </div>

        <PrimaryButton
          onClick={handleContinue}
          disabled={state.challenges.length === 0 || isLoading}
          fullWidth
        >
          {isLoading ? (
            <div className="flex items-center justify-center gap-2">
              <LoadingSpinner size="sm" />
              <span>Loading...</span>
            </div>
          ) : (
            'Continue'
          )}
        </PrimaryButton>
      </div>
    </div>
  )
}

export default Step2Page

